//  See embeddable docs for the use of these events.
//  These events will be pushed on the window to interact with a parent window
class PostMessageEvent {
    /**
     * @param {String} source
     * @param {String} type
     * @param {String} version
     * @param {Object} data
     */
    constructor(source, type, version, data) {
        if (!source) {
            throw new Error(`PostMessageEvent: source is required: ${source}`);
        }
        if (!type) {
            throw new Error(`PostMessageEvent: type is required: ${type}`);
        }
        if (!version) {
            throw new Error(`PostMessageEvent: version is required: ${version}`);
        }
        if (!/(^[1-9][0-9]*)$/.test(version)) {
            throw new Error(`PostMessageEvent: version not of format x: ${version}`);
        }

        this.id = generateHex64Characters();
        this.time = new Date().toISOString();
        this.source = `helenapro.${source}`;
        this.type = `be.healthconnect.helenapro.calendar.${type}+v${version}`;
        this.data = data;
        console.log(this);
        Object.freeze(this);
    }
}

function generateHex64Characters() {
    const randomBytes = new Uint8Array(32);
    crypto.getRandomValues(randomBytes);
    return Array.from(randomBytes).map(byte => byte.toString(16).padStart(2, '0')).join('');
}

export default PostMessageEvent;
